import { render } from "./tour.vue?vue&type=template&id=374dda24&ts=true"
import script from "./tour.vue?vue&type=script&lang=ts"
export * from "./tour.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__